export class OAuth2Message {
    message: string = 'подождите...'
    isAuthFailed: boolean = false
}
